<template>
  <b-form @submit.prevent>
    <b-form-group :label="placeHolder" label-for="language-picker">
      <v-select
        @search="handleSearch"
        :disabled="isDisabled"
        id="language-picker"
        dir="rtl"
        :filterable="false"
        v-if="languageList"
        :reduce="(language) => language.languageId"
        v-model="selectedLanguage"
        :options="languageList"
        label="title"
        placeholder="زبان را انتخاب کنید"
      >
        <template #no-options>هیچ زبانی جهت نمایش وجود ندارد</template>
      </v-select>
    </b-form-group>
  </b-form>
</template>
<script>
export default {
  emits: ["getLanguage"],
  props: {
    defaultLanguageId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeHolder: {
      type: [String, null],
      required: false,
      default: "انتخاب زبان مورد نظر",
    },
  },
  watch: {
    selectedLanguage: {
      handler(val) {
        this.$emit("getLanguage", val);
      },
    },
    defaultLanguageId: {
      handler(val) {
        if (val && val != "" && val != 0) {
          this.getAllLanguages();
        }
      },
    },
  },
  mounted() {
    this.getAllLanguages();
  },
  data() {
    return {
      languageList: null,
      selectedLanguage: null,
      searchVal: null,
      timeout: null,
    };
  },
  methods: {
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchVal = searchValue;
        loadingFn(true);
        await this.getAllLanguages();
        loadingFn(false);
      }, 300);
    },
    async getAllLanguages() {
      try {
        let qParams = {
          count: 10,
          pageNumber: 1,
        };
        if (this.defaultCourseId) {
          qParams["courseId"] = this.defaultCourseId;
        }
        if (this.searchVal && this.searchVal != "") {
          qParams["searchCommand"] = this.searchVal;
        }
        let _this = this;
        let getAllLanguages = new GetAllLanguages(_this);
        getAllLanguages.setRequestParam(qParams);
        await getAllLanguages.fetch((response) => {
          if (response.isSuccess) {
            _this.languageList = response.data.languages;
            if (_this.defaultLanguageId) {
              _this.selectedLanguage = _this.defaultLanguageId;
            }
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    vSelect,
  },
};
import { BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetAllLanguages } from "@/libs/Api/Language";
</script>
